const state ={
    desc:'了解更多'
  }
  const mutations = {}
  const actions = {}
  const getters={}
  export default {
    state,
    mutations,
    actions,
    getters
  }